// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8daa71b0","444":"dc6b35b9","615":"2f0bba47","687":"54a59bc7","758":"051a51b5","791":"5cbecbf7","825":"fe861fef","900":"d4fbd6d4","972":"3c8e181f"}[chunkId] + ".chunk.js";
};